'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getGdprSubmissionText;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _links = require('./links');

var _links2 = _interopRequireDefault(_links);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getGdprSubmissionText(partnerRequestState, partnerPrivacyLink, partnerCompany, partnerId) {
  var partnerSignup = !!partnerId;
  var shouldSubmitPartnerPolicy = partnerRequestState && partnerRequestState.isSuccessful() && partnerSignup && partnerPrivacyLink;
  var partnerSubmissionText = '';
  if (shouldSubmitPartnerPolicy) {
    partnerSubmissionText = shouldSubmitPartnerPolicy ? '<br /> ' + _I18n2.default.text('core.landingPage.core.gdprPartnerSubmission', {
      partnerCompany: partnerCompany,
      link: partnerPrivacyLink
    }) : null;
  }

  return _I18n2.default.text('core.termsOfService') + '<br />' + _I18n2.default.text('core.landingPage.core.gdprSubmission', { link: _links2.default.privacy() }) + ' ' + partnerSubmissionText;
}
module.exports = exports['default'];